import styled from 'styled-components'
import { getMaxWidthStyle } from 'components/mixins'
import { MAX_CONTENT_WIDTH, SPACE, mq } from 'Theme'

const PostContainer = styled('div')`
  ${getMaxWidthStyle(MAX_CONTENT_WIDTH.ARTICLE)};

  isolation: isolate;

  padding-top: ${SPACE.XS};
  padding-bottom: ${SPACE.XL};

  ${mq.from.M`
    padding-top: ${SPACE.M};
    padding-bottom: ${SPACE.XXL};
  `}
`

export default PostContainer
